import { SuiteManifest } from '../manifest';
import { platformRoutes } from './routes';

export const platformManifest: SuiteManifest = {
  id: 'platform',
  code: 'S10_PLAT',
  name: 'Platform & Settings',
  basePath: '/platform',
  icon: 'settings',
  description: 'Academy white-labeling, skills and topic taxonomies, per-suite license management, API keys, and audit logs.',
  requiredPermission: 'settings.manage',
  allowedRoles: ['owner', 'admin'],
  nav: [
    { label: 'Branding & Domain', path: '/platform/branding', icon: 'palette', group: 'Configuration', status: 'live' },
    { label: 'Skills & Topic Taxonomy', path: '/platform/skills', icon: 'brain', group: 'Academic Taxonomy', status: 'live' },
    { label: 'Suite Licensing', path: '/platform/suites', icon: 'layers', group: 'Configuration', status: 'live' },
    { label: 'API Keys & Hooks', path: '/platform/api-keys', icon: 'key', group: 'Integration', status: 'live' },
    { label: 'Access Control & RBAC', path: '/platform/access-control', icon: 'shield-check', group: 'Security', status: 'live' },
    { label: 'Audit Trail', path: '/platform/audit-logs', icon: 'shield', group: 'Security', status: 'live' },
    { label: 'Import / Export', path: '/platform/import-export', icon: 'download', group: 'Data', status: 'live' },
  ],
  routes: platformRoutes,
};

export { platformRoutes } from './routes';
export default platformManifest;
